var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'app_hidden': _vm.isModalExist },attrs:{"id":"app"}},[_c('RouterView'),_vm._v(" "),_c('PortalTarget',{attrs:{"name":"modal"},on:{"change":_vm.onModalPortalChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }